/**
 * CockpitPerformancePorDataResponse
 * @author ftgibran
 */
import {Model, IResource, Collection, Dictionary, $} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import CockpitRequest from '@/model/request/CockpitRequest'

export default class CockpitPerformancePorDataResponse extends Model {
  readonly $name: string = 'CockpitPerformancePorDataResponse'

  entregue: Dictionary<number | null> = {
    emAtraso: null,
    semDataPrevisao: null,
    d0: null,
    d1: null,
    d2: null,
    d3: null,
    d4: null,
    d5: null,
    d6: null,
    d7: null,
    d8: null,
    d9: null,
    d10plus: null,
  }

  pendente: Dictionary<number | null> = {
    emAtraso: null,
    semDataPrevisao: null,
    d0: null,
    d1: null,
    d2: null,
    d3: null,
    d4: null,
    d5: null,
    d6: null,
    d7: null,
    d8: null,
    d9: null,
    d10plus: null,
  }

  todaySemDataPrevisao: number | null = null
  todayForaDoPrazo: number | null = null
  todayNoPrazo: number | null = null

  d0plus: number | null = null
  d0: number | null = null
  d1past: number | null = null
  d2past: number | null = null
  d3past: number | null = null
  d4past: number | null = null
  d5past: number | null = null
  d6pastPlus: number | null = null

  async getCockpitPerformancePorData(request: CockpitRequest, spinner = 'getCockpitPerformancePorData') {
    const fetch = async () => await this.POST(`/user/me/cockpit/performance/data`, request)
    return await $.await.run(fetch, spinner)
  }
}
